"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Verification/VerificationLockedPage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _session = require('shared/selectors/session');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');
var _BroadcastsVerification = require('web/components/Upsells/BroadcastsVerification'); var _BroadcastsVerification2 = _interopRequireDefault(_BroadcastsVerification);







const VerificationLockedPage = ({ isRequested, isRequesting, onRequest }) => {
  const orgKey = _hooks.useAppSelector.call(void 0, _session.selectSelectedOrgKey)
  const amIAdmin = _hooks.useAppSelector.call(void 0, state => !!orgKey && _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  return (
    _react2.default.createElement(_BroadcastsVerification2.default, {
      isAdmin: amIAdmin,
      isRequested: isRequested,
      isRequesting: isRequesting,
      onRequest: onRequest, __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
    )
  )
}

exports. default = _react.memo.call(void 0, VerificationLockedPage)
